import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import logoWhite from '../../Assets/JMD INFORMATIQUE WHITE.png';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__inner">
        {/* Logo */}
        <Link to="/" className="navbar__logo" onClick={closeMenu}>
          <img
            src={logoWhite}
            alt="JMD Informatique"
            className="navbar__logo-img"
          />
        </Link>

        {/* Phone CTA - always visible */}
        <a href="tel:0781165306" className="navbar__phone">
          <i className="fa-solid fa-phone"></i>
          <span>07 81 16 53 06</span>
        </a>

        {/* Hamburger */}
        <button
          className={`navbar__burger ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu de navigation"
          aria-expanded={menuOpen}
          aria-controls="navbar-menu"
        >
          <span /><span /><span />
        </button>

        {/* Nav links */}
        <ul id="navbar-menu" className={`navbar__menu ${menuOpen ? 'navbar__menu--open' : ''}`}>
          <li>
            <Link
              to="/"
              className={`navbar__link ${location.pathname === '/' ? 'active' : ''}`}
              onClick={closeMenu}
            >
              Accueil
            </Link>
          </li>
          <li>
            <Link
              to="/contact"
              className={`navbar__link ${location.pathname === '/contact' ? 'active' : ''}`}
              onClick={closeMenu}
            >
              Contact
            </Link>
          </li>
          <li>
            <a href="tel:0781165306" className="navbar__link navbar__link--cta" onClick={closeMenu}>
              <i className="fa-solid fa-phone"></i> Appeler
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
